import React, { Component } from "react";
import ListItems from "./ListItems";
export class EmployeeList extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  renderListItems(item) {
    
    return item.sort((a,b)=>a.sort - b.sort).map((x, index) => {
      // console.log(x);
      if (x.status_ == "active") {
        return <ListItems key={index} {...x} />;
      }
    });
  }
  render() {
    const { crewContent } = this.props;
    return (
      <section id="listContainer" className="grid">
        {this.renderListItems(crewContent)}
      </section>
    );
  }
}
export default EmployeeList;
